import { render, staticRenderFns } from "./InboxEmailDetail.vue?vue&type=template&id=72841e5e&scoped=true"
import script from "./InboxEmailDetail.vue?vue&type=script&lang=js"
export * from "./InboxEmailDetail.vue?vue&type=script&lang=js"
import style0 from "./InboxEmailDetail.vue?vue&type=style&index=0&id=72841e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72841e5e",
  null
  
)

export default component.exports